import { useCallback } from 'react';
import { getVinStylesData, buildStylesBasicPathFromVin, VehicleVinModel } from 'client/data/models/vehicle-vin';
import { getMetricApiOptions } from 'client/utils/metrics-hoc';
import {
  fireDecodePixels,
  fireVinDecodeMatchTypePixel,
  fireVinErrorTracking,
} from 'site-modules/shared/utils/appraisal/common-utils';

export function useVinDecoder({ creativeId, apiMetrics, setModelValue }) {
  const decodeVin = useCallback(
    async vinInputValue => {
      const stylesResponse = await getVinStylesData({
        vin: vinInputValue,
        apiOptions: getMetricApiOptions(apiMetrics),
      });

      setModelValue(buildStylesBasicPathFromVin({ vin: vinInputValue }), VehicleVinModel, stylesResponse);

      const styles = stylesResponse?.results;
      fireDecodePixels({ stylesLength: styles?.length, vinStylesData: stylesResponse, creativeId });
      fireVinDecodeMatchTypePixel(stylesResponse?.matchType, creativeId);

      if (stylesResponse?.isPubStateInvalid) {
        fireVinErrorTracking(vinInputValue, stylesResponse, creativeId);
      }

      return stylesResponse;
    },
    [apiMetrics, creativeId, setModelValue]
  );

  return { decodeVin };
}
